module.exports = __webpack_public_path__ + "static/media/horse.8c44bf88.svg";